import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { ProcessSteps } from '../ui/ProcessSteps';
export function HomeProcess() {
  return <section className="bg-paper" aria-labelledby="process-title" data-id="element-184" data-mp="2olyw4o63os4t">
      <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32" data-id="element-185" data-mp="2jrunm0h6sc1m">
        <SectionHeading id="process-title" eyebrow="Our Search Process" title="A clear, structured search — from brief to introduction." intro="Every engagement follows the same disciplined sequence, so you always know where a search stands and what comes next." data-id="element-186" data-mp="2eum2ps4nltwo" />
        <div className="mt-16" data-id="element-187" data-mp="20ti35iktrfqq">
          <ProcessSteps data-id="element-188" data-mp="20ujp4i3dpmn8" />
        </div>
      </div>
    </section>;
}